import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import autenticacao from "@/store/modules/autenticacao";

export default createStore({
	modules: { autenticacao },
	strict: process.env.NODE_ENV !== "production",
	plugins: [createPersistedState()],
});
